import { frontendmodule } from '@Hibachi/frontend/frontend.module';
import {
	PublicService,
	RequestService,
	ObserverService,
	UtilityService,
	RbKeyService,
	LocalStorageService,
	alertmodule
} from '@Hibachi/core/core.module';

// Controllers
import { BookListingController } from './controllers/book-listing';
import { BookSingleController } from './controllers/book-single';
import { BookSearchController } from './controllers/book-search';
import { BookSelfAssignController } from './controllers/book-self-assign';
import { BookTileController } from './controllers/book-tile';
import { ImageController } from './controllers/image-controller';
import { ImageGalleryController } from './controllers/image-gallery-controller';
import { LessonEditorController } from './controllers/lesson-editor';
import { LessonListingController } from './controllers/lesson-listing';
import { MyProfileController } from './controllers/my-profile';
import { PortfolioListingController } from './controllers/portfolio-listing';
import { PortfolioEditorController } from './controllers/portfolio-editor';
import { DistrictAdminController } from './controllers/district-admin';
import { AdminAccountImportController } from './controllers/admin-account-import';
import { DistrictUsersController } from './controllers/district-users';
import { HelpController } from './controllers/help';

// Services
import { ApiService } from './services/apiservice';
import { BookService } from './services/bookservice';
import { ContentService } from './services/contentservice';
import { FormService } from './services/formservice';
import { LessonService } from './services/lessonservice';
import { LicenseService } from './services/licenseservice';
import { ImageService } from './services/imageservice';
import { PortfolioService } from './services/portfolioservice';
import { AdminAccountService } from './services/adminAccountService';
import { ListingModalService } from './services/listing-modal-service';
import { DavisAlertService } from './services/davisAlertService';
import { ShepherdService } from './services/shepherdservice';
// Directives
import { AddButtonModal } from './directives/add-button-modal';
import { AddBookModal } from './directives/add-book-modal';
import { AddContentModule } from './directives/add-content-module';
import { AddFormModal } from './directives/add-form-modal';
import { AddPortfolioPageModal } from './directives/add-portfolio-page-modal';
import { AddVideoModal } from './directives/add-video-modal';
import { BookPreview } from './directives/book-preview';
import { BookResourcesModal } from './directives/book-resources-modal';
import { CompareImagesModal } from './directives/modals/compare-images-modal';
import { ContentModule } from './directives/content-module';
import { ContentEditable } from './directives/contenteditable';
import { FolderCard } from './directives/folder-card';
import { ImageCaptionModal } from './directives/image-caption-modal';
import { ImageCollectionEditModal } from './directives/modals/image-collection-edit-modal';
import { ImageCropperModal } from './directives/image-cropper-modal';
import { ImageDetailModal } from './directives/image-detail-modal';
import { ImageGallerySlideshow } from './directives/image-gallery-slideshow';
import { ImageGallerySlideshowModal } from './directives/image-gallery-slideshow-modal';
import { ImageUploadModal } from './directives/image-upload-modal';
import { ImportContentModal } from './directives/import-content-modal';
import { ImportLessonContentModal } from './directives/import-lesson-content-modal';
import { LessonCard } from './directives/lesson-card';
import { NotesPanel } from './directives/notes-panel';
import { Pagination } from './directives/pagination';
import { DavisPreloader } from './directives/davis-preloader';
import { SaveAsModal } from './directives/save-as-modal';
import { DuplicateModal } from './directives/modals/duplicate-modal';
import { ArchiveModal } from './directives/modals/archive-modal';
import { AgreementPrivacyModal } from './directives/modals/agreement-privacy-modal';
import { BookPageAssets } from './directives/book-page-assets';
import { EditLessonDescriptionModal } from './directives/modals/edit-lesson-description-modal';

import { PortfolioFolderCard } from './directives/portfolio-folder-card';
import { PortfolioCard } from'./directives/portfolio-card';
import { AdminAccountListing } from'./directives/admin-account-listing';
import { AdminBulkPermission } from'./directives/admin-bulk-permission';
import { AdminAvailableLicense } from'./directives/admin-available-license';
import { AgreementPrivacy } from'./directives/agreement-privacy';

import { AddEditFolderModal } from './directives/modals/add-edit-folder-modal';
import { ConfirmDeleteModal } from './directives/modals/confirm-delete-modal';
import { ConfirmDeletePortfolioFolderModal } from './directives/modals/confirm-delete-portfolio-folder-modal';
import { ConfirmModalInnerDialog } from './directives/modals/confirm-modal-inner-dialog';
import { TranslatedTextModal } from './directives/modals/translated-text-modal';
import { ShareSettingsModal } from './directives/modals/share-setting-modal';
import { SupportTicketModal } from './directives/modals/support-ticket-modal';
import { ExportContentModal } from './directives/modals/export-content-modal';
import { MoveContentModal } from './directives/modals/move-content-modal';
import { ImageCollectionShareModal } from './directives/modals/image-collection-share-modal';
import { ImageCollectionCopyModal } from './directives/modals/image-collection-copy-modal';
import { CopyContentModal } from './directives/modals/copy-content-modal';
import { ConfirmDeleteLicenseModal } from './directives/modals/confirm-delete-license-modal';
import { LicenseReassignModal } from './directives/modals/license-reassign-modal';
import { PortfolioAdministerShareModal } from './directives/modals/portfolio-administer-share-modal';
//
import { VideoPlayerModal } from './directives/modals/video-player';

import { UserSummaryModal } from './directives/modals/usersummary-modal';

import { ConfirmActionModal } from './directives/modals/confirm-action-modal';

// Image Modals
import { ModalImageFullscreen } from './directives/modals/modal-image-fullscreen';
import { AddEditPageImageNoteModal } from './directives/modals/add-edit-page-image-note-modal';

import { TextHighlighterFilter } from './TextHighlighterFilter';

var davisdigitalfrontendmodule = angular
	.module('davisdigitalfrontend', [frontendmodule.name, 'ngSanitize', alertmodule.name])

	// Constants
	.constant('davisFrontendBasePath', '/custom/client/src')

	.filter('highlighter', TextHighlighterFilter)
	.filter('dateFormat', function() {
        return function(items) {
            return new Date(items);
        };
    })

	// Directives
	.directive('addButtonModal', AddButtonModal.Factory())
	.directive('addBookModal', AddBookModal.Factory())
	.directive('addContentModule', AddContentModule.Factory())
	.directive('addFormModal', AddFormModal.Factory())
	.directive('addPortfolioPageModal', AddPortfolioPageModal.Factory())
	.directive('addVideoModal', AddVideoModal.Factory())
	.directive('bookPreview', BookPreview.Factory())
	.directive('bookResourcesModal', BookResourcesModal.Factory())
	.directive('compareImagesModal', CompareImagesModal.Factory())
	.directive('contentModule', ContentModule.Factory())
	.directive('contenteditable', ContentEditable.Factory())
	.directive('folderCard', FolderCard.Factory())
	.directive('lessonCard', LessonCard.Factory())
	.directive('imageCaptionModal', ImageCaptionModal.Factory())
	.directive('imageCollectionEditModal', ImageCollectionEditModal.Factory())
	.directive('imageCropperModal', ImageCropperModal.Factory())
	.directive('imageDetailModal', ImageDetailModal.Factory())
	.directive('imageGallerySlideshow', ImageGallerySlideshow.Factory())
	.directive('imageGallerySlideshowModal', ImageGallerySlideshowModal.Factory())
	.directive('imageUploadModal', ImageUploadModal.Factory())
	.directive('importContentModal', ImportContentModal.Factory())
	.directive('importLessonContentModal', ImportLessonContentModal.Factory())
	.directive('notesPanel', NotesPanel.Factory())
	.directive('bookPageAssets', BookPageAssets.Factory())

	.directive('davisPagination', Pagination.Factory())
	.directive('davisPreloader', DavisPreloader.Factory())

	.directive('saveAsModal', SaveAsModal.Factory())
	.directive('portfolioCard', PortfolioCard.Factory())
	.directive('portfolioFolderCard', PortfolioFolderCard.Factory())
	
	
	.directive('adminAccountListing', AdminAccountListing.Factory())
	.directive('adminBulkPermission', AdminBulkPermission.Factory())
	.directive('adminAvailableLicense', AdminAvailableLicense.Factory())
	.directive('agreementPrivacy', AgreementPrivacy.Factory())
	
	.directive('addEditFolderModal', AddEditFolderModal.Factory())
	
	.directive('confirmDeleteModal', ConfirmDeleteModal.Factory())
	.directive('confirmDeletePortfolioFolderModal', ConfirmDeletePortfolioFolderModal.Factory())
	.directive('confirmModalInnerDialog', ConfirmModalInnerDialog.Factory())
	
	.directive('videoPlayerModal', VideoPlayerModal.Factory())
	
	.directive('shareSettingsModal', ShareSettingsModal.Factory())
	.directive('supportTicketModal', SupportTicketModal.Factory())
	.directive('exportContentModal', ExportContentModal.Factory())
	.directive('duplicateModal',    DuplicateModal.Factory())
	.directive('moveContentModal', MoveContentModal.Factory())
	.directive('archiveModal', ArchiveModal.Factory())
	.directive('agreementPrivacyModal', AgreementPrivacyModal.Factory())
	.directive('copyContentModal', CopyContentModal.Factory())
	.directive('imageCollectionShareModal', ImageCollectionShareModal.Factory())
	.directive('imageCollectionCopyModal', ImageCollectionCopyModal.Factory())
	.directive('editLessonDescriptionModal', EditLessonDescriptionModal.Factory())
	.directive('translatedTextModal', TranslatedTextModal.Factory())
	.directive('userSummaryModal', UserSummaryModal.Factory())
	.directive('confirmDeleteLicenseModal', ConfirmDeleteLicenseModal.Factory())
	.directive('licenseReassignModal', LicenseReassignModal.Factory())
	.directive('portfolioAdministerShareModal', PortfolioAdministerShareModal.Factory())
	
	// Image Directives
	.directive('modalImageFullscreen', ModalImageFullscreen.Factory())
    .directive('addEditPageImageNoteModal', AddEditPageImageNoteModal.Factory() )
    
    //generic
    .directive('confirmActionModal', ConfirmActionModal.Factory() )
    
    
	// Controllers
	.controller('bookListingController', BookListingController)
	.controller('helpController', HelpController)
	.controller('bookTileController', BookTileController)
	.controller('bookSingleController', BookSingleController)
	.controller('bookSearchController', BookSearchController)
	.controller('bookSelfAssignController', BookSelfAssignController)
	.controller('lessonEditorController', LessonEditorController)
	.controller('lessonListingController', LessonListingController)
	.controller('imageController', ImageController)
	.controller('imageGalleryController', ImageGalleryController)
	.controller('myProfileController', MyProfileController)
    .controller('portfolioListingController', PortfolioListingController)
    .controller('portfolioEditorController', PortfolioEditorController)
    .controller('districtAdminController', DistrictAdminController)
    .controller('districtUsersController', DistrictUsersController)
	.controller('adminAccountImportController', AdminAccountImportController)
       
	// Services
	.service('apiService', ApiService)
	.service('bookService', BookService)
	.service('contentService', ContentService)
	.service('formService', FormService)
	.service('imageService', ImageService)
	.service('lessonService', LessonService)
	.service('licenseService', LicenseService)
	.service('portfolioService', PortfolioService)
	.service('adminAccountService', AdminAccountService)
	.service('davisAlertService', DavisAlertService)
	
	.service('listingModalService', ListingModalService)
	.service('shepherdService', ShepherdService)

	.config([
		'$logProvider',
		'$locationProvider',
		($logProvider: ng.ILogProvider, $locationProvider: ng.ILocationProvider) => {
			// this is just to demonstrate what we can do with webpack injected values
			if (__DEBUG_MODE__) {
				console.log(hibachiConfig);
			}
			$logProvider.debugEnabled(__DEBUG_MODE__);
			$locationProvider.html5Mode({ enabled: true, requireBase: false, rewriteLinks: false });
		},
	]);

export {
	davisdigitalfrontendmodule,
	// From DavisDigital Module
	ApiService,
	BookService,
	ContentService,
	FormService,
	LessonService,
	LicenseService,
	ImageService,
	PortfolioService,
	AdminAccountService,
	ListingModalService,
	DavisAlertService,
	ShepherdService,
	// From Hibachi
	PublicService,
	RequestService,
	ObserverService,
	UtilityService,
	RbKeyService,
	LocalStorageService,
	alertmodule
};
